import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CartModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

export interface UpdatePaymentMethodParameter extends ApiParameter {
    paymentMethod: string;
}

export interface UpdatePaymentMethodModel {
    paymentMethod: string;
}

type HandlerType = CustomApiHandler<UpdatePaymentMethodParameter, UpdatePaymentMethodModel>;

export const DispatchCustomPaymentMethod: HandlerType = props => {
    props.dispatch({
        type: "Custom/PaymentMethod",
        paymentMethod: props.parameter.paymentMethod,
    });
};

export const chain = [DispatchCustomPaymentMethod];

const updatePaymentMethod = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        paymentMethod: "Bill",
    },
    "updatePaymentMethod",
);
export default updatePaymentMethod;
